import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fast-quote-modal',
  templateUrl: './fast-quote-modal.component.html',
  styleUrls: ['./fast-quote-modal.component.scss']
})
export class FastQuoteModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
